module.exports = __webpack_public_path__ + "static/media/icon-prescriptions.7711c22c.svg";